import { check_list_delete } from "../../utils/endpoints";

export default function CheckListDelete({
  check_list,
  removeCheckList,
  context,
}) {
  const handleDelete = async () => {
    let response = await context.httpRequest(
      "delete",
      check_list_delete.replace("*", check_list.id),
      null,
      context.session.token
    );

    if (response.result) {
      context.openMessage(
        "success",
        "La bozza è stata eliminata correttamente"
      );
      removeCheckList(check_list.id);
      document.querySelector("#close-modal-button").click();
    }
  };

  return (
    <>
      <div className="w-75 text-center mx-auto">
        <strong className="d-block">
          Confermi di voler eliminare la bozza selezionata?
        </strong>
        <span className="mt-3 mb-4 d-block">
          Questa è un operazione irreversibile e non potrai recuperare la
          seguente bozza una volta eliminata.
        </span>
      </div>
      <button
        className="q8-blue-button p-3 w-100"
        onClick={() => handleDelete()}
      >
        ELIMINA BOZZA
      </button>
    </>
  );
}
